import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useStore = create()(
    persist(
        (set) => ({
            // Auth state
            user: null,
            wallet: null,
            isAuthenticated: false,
            accessToken: null,
            refreshToken: null,

            // Gaming OAuth state (persisted across redirects)
            gamingAuthState: null,
            gamingAuthPlatform: null,
            gamingAuthLinkMode: null,

            // Session / redirect state
            sessionToken: null,
            returnUrl: null,

            // Cookie consent
            cookieConsent: null,

            // Actions - Auth
            setAuth: (user, accessToken, refreshToken) =>
                set({ user, accessToken, refreshToken, isAuthenticated: true }),

            updateWallet: (wallet) => set({ wallet }),

            logout: () => set({
                user: null,
                wallet: null,
                accessToken: null,
                refreshToken: null,
                isAuthenticated: false
            }),

            // Actions - Gaming OAuth
            setGamingAuth: (state, platform, linkMode) =>
                set({ gamingAuthState: state, gamingAuthPlatform: platform, gamingAuthLinkMode: linkMode }),
            clearGamingAuth: () =>
                set({ gamingAuthState: null, gamingAuthPlatform: null, gamingAuthLinkMode: null }),

            // Actions - Session / redirect
            setReturnUrl: (url) => set({ returnUrl: url }),
            clearReturnUrl: () => set({ returnUrl: null }),

            setSessionToken: (token) => set({ sessionToken: token }),

            // Actions - Cookie consent
            setCookieConsent: (consent) => set({ cookieConsent: consent }),
        }),
        { name: 'blish-storage' }
    )
);
